export default {
  'validation.required': 'Required',
  'validation.invalid.email': 'Not a valid email address',
  'validation.password.length': 'Password has to be at least 8 characters long',
  'validation.password.lowerCase': 'Password should contain at least 1 lowercase',
  'validation.password.upperCase': 'Password should contain at least 1 uppercase',
  'validation.password.special': 'Password should contain at least 1 special character',
  'validation.password.match': 'Passwords do not match',
  'validation.monetaryValue': 'Wrong monetary value',
  'error.message': 'Something went wrong...',
  'error.registeredEmail': 'The email address you have entered is already registered',
  'error.processRequest': 'Unable to process request',
  'error.load': 'No questions here',
  'error.wrongEmailPassword': 'Invalid email address or password',
  'toastr.success': 'Success',
  'toastr.resetPassword':
    'Уou have successfully reset your password. Please log in with the new password below.',
  'error.email': 'The email address is already registered'
};
